import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import ArrowIcon from '@assets/svgs/learn/arrow_right_6.svg'
import UndoIcon from '@assets/svgs/learn/undo.svg'
import {CommonColors} from '@utils/CommonStyles'
import {useDispatch, useSelector} from 'react-redux'
import {updateIsCurrentChoose} from '@redux/vocabulary/vocabulary'
import CloseIcon2 from '@assets/svgs/learn/close_2.svg'
import CheckIcon3 from '@assets/svgs/learn/check_3.svg'
import {useLocation, useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import {styleByTextTag} from '@utils'
import vocabularyRequest from '@apis/vocabulary'

const Footer = ({
  vocabularyData,
  currentVocabulary,
  currentIndexVocabulary,
  currentIndexQuestion,
  setCurrentIndexQuestion,
}: {
  vocabularyData: any
  currentVocabulary: any
  currentIndexVocabulary: any
  currentIndexQuestion: any
  setCurrentIndexQuestion: any
}) => {
  const {currentChoose} = useSelector((state: any) => state.vocabulary)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const {setName, setId, rootRout, entry_point, task_id} = location.state || {}

  const handleClickBtn = () => {
    if (currentChoose && !currentChoose.is_true_answer) {
      dispatch(updateIsCurrentChoose(null))
    } else {
      if (
        currentIndexQuestion ===
        vocabularyData[currentIndexVocabulary]?.questions.length - 1
      ) {
        const params = {vocabularyId: currentVocabulary?.vocabularyId}
        vocabularyRequest.saveVocabularies(params)
      }
      if (
        currentIndexVocabulary === vocabularyData?.length - 1 &&
        currentIndexQuestion ===
          vocabularyData[currentIndexVocabulary]?.questions.length - 1
      ) {
        navigate(PATH.LEARN_VOCABULARY_RESULT, {
          state: {setName, setId, rootRout, entry_point, task_id},
        })
      } else {
        setCurrentIndexQuestion((pre: number) => pre + 1)
      }
    }
  }

  return (
    <Box
      w={'100%'}
      py={'40px'}
      bg={
        currentIndexQuestion === 0 || !currentChoose?.is_true_answer
          ? 'white'
          : '#F6FFED'
      }
      mt={'24px'}>
      <Flex
        className="container-xl"
        gap={'8px'}
        maxW={'1000px'}
        justifyContent={'space-between'}
        alignItems={'center'}>
        <Box>
          {currentChoose && (
            <Flex gap={'24px'}>
              <Center
                flexShrink={0}
                h={{base: '40px', md: '64px'}}
                w={{base: '40px', md: '64px'}}
                bg={currentChoose?.is_true_answer ? 'white' : '#FF4D4F'}
                borderRadius={'50%'}>
                <Image
                  w={currentChoose?.is_true_answer ? '30px' : '50px'}
                  src={currentChoose?.is_true_answer ? CheckIcon3 : CloseIcon2}
                />
              </Center>
              <Flex flexDirection={'column'}>
                <Text
                  fontSize={{base: '16px', md: '24px'}}
                  fontWeight={600}
                  color={currentChoose?.is_true_answer ? '#52C41A' : '#F5222D'}>
                  {currentChoose?.is_true_answer
                    ? 'Chính xác'
                    : 'Chưa chính xác'}
                </Text>
                <Text
                  fontSize={{base: '14px', md: '16px'}}
                  sx={{
                    '.vocabulary-text': {
                      color: currentChoose?.is_true_answer
                        ? '#52C41A'
                        : '#F5222D',
                    },
                  }}>
                  {styleByTextTag(currentChoose?.feedback)}
                </Text>
              </Flex>
            </Flex>
          )}
        </Box>
        <Center
          flexShrink={0}
          cursor={'pointer'}
          gap={'12px'}
          h={'48px'}
          w={{base: '70px', md: '140px'}}
          borderRadius={'16px'}
          bg={
            currentIndexQuestion === 0
              ? CommonColors.primary
              : currentChoose && !currentChoose.is_true_answer
                ? '#E6F7FF'
                : '#52C41A'
          }
          onClick={handleClickBtn}>
          <Text
            fontSize={{base: '14px', md: '16px'}}
            fontWeight={700}
            color={
              currentChoose && !currentChoose.is_true_answer
                ? '#096DD9'
                : 'white'
            }>
            {currentChoose?.is_true_answer || currentIndexQuestion === 0
              ? 'Tiếp tục'
              : 'Thử lại'}
          </Text>
          <Image
            display={{base: 'none', md: 'block'}}
            src={
              currentChoose && !currentChoose.is_true_answer
                ? UndoIcon
                : ArrowIcon
            }
          />
        </Center>
      </Flex>
    </Box>
  )
}

export default Footer
